import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

const ExploriEditWarningModal = ({ store }) => {
    const close = () => {
        store.exploriLiteEditWarning.show = false
        store.pendingExploriEdit = null
    }

    const confirm = () => {
        store.exploriLiteEditWarning.show = false
        if (store.pendingExploriEdit) {
            store.pendingExploriEdit.cb()
            store.pendingExploriEdit = null
        }
    }

    const { show, questionLevel } = store.exploriLiteEditWarning

    return (
        <Modal
            show={show}
            onClose={close}
        >
            <div id="explori-edit-warning-modal">
                <div className="uc-modal__header">
                    <h2>{i18n.t('exploriLiteEditWarningModal.title')}</h2>
                    <p
                        className="uc-modal__desc"
                        dangerouslySetInnerHTML={{ __html: i18n.t(`exploriLiteEditWarningModal.body.${questionLevel}`) }}
                    />
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        onClick={confirm}
                        cssClass="regular primary"
                        label={i18n.t('exploriLiteEditWarningModal.confirm')}
                    />
                    <Button
                        onClick={close}
                        cssClass="regular tertiary"
                        label={i18n.t('cancel')}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default observer(ExploriEditWarningModal)
